<template>
  <div class="animated fadeIn">
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/university/newUniRequest'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <b-tabs class="mb-3" pills vertical v-model="tabIndex">
        <div class="d-flex justify-content-center mt-3"></div>
        <b-tab :title="'کلیات طرح'" active>
          <b-form-group>
            <div class="d-flex" dir="ltr">
              <label
                for="switch_1"
                :class="
                  initialObligation ? 'ml-3 mb-0 done' : 'ml-3 mb-0 required'
                "
              >
                اینجانب تعهد می کنم با مطالعه و آگاهی از
                <b-button
                  id="downLoad"
                  title="دانلود RFP"
                  variant="link"
                  href="https://api.biodcportal.com/setad/public/RFP%20%D9%81%D8%B1%D8%A7%D8%AE%D9%88%D8%A7%D9%86%20%D9%81%D9%86%D8%A7%D9%88%D8%B1%DB%8C.pdf"
                >
                  <b-tooltip
                    placement="bottomleft"
                    target="downLoad"
                    triggers="hover"
                    variant="info"
                    >دانلود RFP</b-tooltip
                  >ارائه شده RFP</b-button
                >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست طرح کلان
                در سامانه اقدام می نمایم
              </label>
              <b-form-checkbox
                id="switch_1"
                v-model="initialObligation"
              ></b-form-checkbox>
            </div>
          </b-form-group>
          <hr />
          <h3 class="text-primary mb-4">دانشگاه گرامی</h3>

          <p>
            به ابزار ثبت طرح‌های کلان پژوهشی سامانه تقسیم کار ملی خوش آمدید.
            خواهشمندیم به منظور آغاز فرآیند ثبت طرح کلان اطلاعات زیر را تکمیل
            نمایید:
          </p>
          <b-form-group
            label="عنوان فارسی طرح کلان"
            :class="faSubject ? 'done' : 'required'"
          >
            <b-form-input trim type="text" v-model="faSubject"></b-form-input>
          </b-form-group>

          <b-form-group
            label="عنوان انگلیسی طرح کلان"
            :class="enSubject ? 'done' : 'required'"
          >
            <b-form-input
              trim
              type="text"
              dir="ltr"
              v-model="enSubject"
              @keydown="nameKeydown($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="موضوع طرح کلان"
            :class="catId ? 'done' : 'required'"
          >
            <Select2
              class="myselect2"
              v-model="catId"
              :options="cats"
            ></Select2>
          </b-form-group>
        </b-tab>
        <b-tab disabled :title="'مشخصات مجری و راهبر طرح کلان'"></b-tab>
        <b-tab disabled :title="'اطلاعات تکمیلی مرتبط با اجرای طرح'"></b-tab>
        <b-tab disabled :title="'سطح‌بندی طرح'"></b-tab>
        <b-tab disabled :title="'ساختار شکست کار'"></b-tab>
        <b-tab disabled :title="'هزینه‌ها'"></b-tab>
        <b-tab disabled :title="'زمان‌بندی'"></b-tab>
        <b-tab :title="'تعهدات'" disabled></b-tab>
        <b-tab :title="'مرور نهایی'" disabled></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="!initialObligation || !faSubject || !enSubject || !catId"
          >آغاز فرآیند</b-button
        >
      </div>
    </b-card>

    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
  },
  data() {
    return {
      isLoaded: false,
      initialObligation: false,
      faSubject: "",
      enSubject: "",
      catId: "",
      tabIndex: 1,
      cats: [],
    };
  },

  methods: {
    nameKeydown(enSubject) {
      if (/[^a-zA-Z 0-9]/.test(enSubject.key)) {
        enSubject.preventDefault();
      }
    },
    getUniCats() {
      this.$http
        .get(this.baseUrl + "/setad/university/uniRequest/cats", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.cats = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    start() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/university/uniRequest/",
          {
            initialObligation: this.initialObligation,
            faSubject: this.faSubject,
            enSubject: this.enSubject,
            catId: this.catId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          const title = (
            <div>
              <h5>!ثبت درخواست</h5>
              <span>
                فرآیند ثبت درخواست طرح کلان دانشگاه شما با موفقیت به ثبت رسید.
              </span>
            </div>
          );
          this.toast(title, "info");
          router.push("/university/completeUniRequest/" + res.data.id);
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.getUniCats();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
</style>
